// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import {
  CustomerTriage,
  customerTriageSchema,
} from '@/customer/api/triage-types';

interface ApiResponse {
  data: unknown;
  metadata: { requestId: string };
}

export async function dismissTriageCustomer(
  triageKey: string
): Promise<CustomerTriage> {
  const url = `/v1/customer-triage/${triageKey}/dismiss`;
  const response = await api.post<ApiResponse>(url);

  return parseResponse(customerTriageSchema, response.data.data, {
    schemaName: 'DismissTriageCustomer',
    endpoint: url,
  });
}
